<section class="asset-management-section">
  @if (displayHeader) {
    <ts-page-header [displaySeparationBorder]="true">
      <ng-container page-header-title>
        <p class="font-ts-header-title text-ts-header-title">
          {{ mode === 'income-statement' ? 'Income Statement' : 'Balance Sheet' }}
        </p>
      </ng-container>
      <ng-container page-header-action-bar>
        <report-period-selector
          [loading]="_loading | async"
          [reportPeriod]="reportPeriod"
          (reportPeriodChanged)="reportPeriodChanged.next($event)"
        />
      </ng-container>
    </ts-page-header>
  }

  <ag-grid-angular
    id="teams-grid"
    class="ag-theme-quartz"
    [rowData]="rowData"
    [autoGroupColumnDef]="autoGroupColumnDef"
    [treeData]="true"
    [getDataPath]="getDataPath"
    [columnDefs]="mode === 'balance-sheet' ? balanceSheetColDefs : incomeStatementColDefs"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
  ></ag-grid-angular>
</section>
